import script from "./404.vue?vue&type=script&lang=ts&setup=true"
export * from "./404.vue?vue&type=script&lang=ts&setup=true"

import "./404.vue?vue&type=style&index=0&id=18dd3b74&lang=scss&scoped=true"

import exportComponent from "/media/myr/DATA/WEBS/DULCESDE.COM/NUEVA WEB 2022/vue_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18dd3b74"]])

export default __exports__